// © Microsoft Corporation. All rights reserved.

/**
 * A callback to reset singleton data. Used for server side rendering.
 */
export type ResetCallback = () => void;

/**
 * Global array of callbacks that are used for resetting singleton data.
 */
const resetCallbacks: ResetCallback[] = [];

/**
 * Adds a callback to the global array of reset callbacks.
 * This should only be used to reset singleton data.
 * @param callback The function that resets the singleton data.
 */
export function registerResetCallback(callback: ResetCallback): void {
    resetCallbacks.push(callback);
}

/**
 * Calls all of the reset functions in resetCallbacks.
 * This gets called once on the server side at the beginning of each request.
 */
export function invokeResetCallbacks(): void {
    for (const resetCallback of resetCallbacks) {
        resetCallback();
    }
}